//src/assets/scripts/app.js
import Sphere from './top/module/sphere';
import Stage from './top/module/stage';
import PageJS from './top/page';
import CommonJS from './common';


const common = new CommonJS();

const page = new PageJS(common);
page.init();